export const CRITICAL_ISSUES = 'CRITICAL_ISSUES'; // Критические замечания
export const CALL_LIMIT = 'CALL_LIMIT'; // Ограничение количества вызовов
export const ACCEPTANCE_IN_ONE_STAGE = 'ACCEPTANCE_IN_ONE_STAGE'; // Приемка в один этап
export const STAGED_ACCEPTANCE = 'STAGED_ACCEPTANCE'; // Поэтапная приемка
export const USK_PRE_ACCEPTANCE_PILOT = 'USK_PRE_ACCEPTANCE'; // Предприемка УСК
